export default __webpack_public_path__ + "static/media/home-main.359935c3.svg";